import './index.css';
import './styles/adf.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { router } from './router/router.tsx';
import {
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import { ENVIRONMENT } from '@Env/variables.ts';
import { AuthProvider } from '@Context/CognitoAuthProvider.tsx';
import { initAuth } from '@Auth/amplify.ts';

const sentryConfig: Sentry.BrowserOptions = {
  // This enables automatic instrumentation (highly recommended)
  // If you only want to use custom instrumentation:
  // * Remove the BrowserTracing integration
  // * add Sentry.addTracingExtensions() above your Sentry.init() call
  dsn: 'https://4cf79247d9b69ab15d4526ce197037be@o1224166.ingest.us.sentry.io/4509072949968897',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Or, if you are using react router, use the appropriate integration
    // See docs for support for different versions of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),

    Sentry.replayIntegration({
      // Enables Sentry Session Replay
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
  ],

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // For finer control of sent transactions you can adjust this value, or
  // use tracesSampler
  tracesSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  enabled: ENVIRONMENT === 'prd' || ENVIRONMENT === 'stg' ? true : false,
  environment: ENVIRONMENT,

  // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['localhost', /^https://yourserver.io/api/],
};

initAuth();
Sentry.init(sentryConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <Toaster position="bottom-right" toastOptions={{ duration: 3000 }} />

    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </>
);
